<template>
    <div>
        <h1 class="display-heading">Patient Appointments</h1>

        <div class="table-responsive">
            <table ref="listTable" class="table table-hover">
                <colgroup>
                    <col width="50">
                    <col width="200">
                    <col width="150">
                    <col>
                    <col>
                    <col width="300">
                </colgroup>
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Date</th>
                        <th scope="col">Time</th>
                        <th scope="col">Patient Name</th>
                        <th scope="col">Status</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-show="appointmentList.length === 0">
                        <td :colspan="columnsCount" class="text-center font-italic">
                            {{isTableLoading ? "Loading Data": "No Data"}}
                        </td>
                    </tr>
                    <tr v-for="(appointment, index) in appointmentList" :key="index">
                        <th scope="row">{{index+1}}</th>
                        <td class="text-nowrap">{{appointment.date}}</td>
                        <td class="text-nowrap">
                            {{appointment.time}}
                        </td>
                        <td class="text-nowrap">{{appointment.patientName}}</td>
                        <td class="text-nowrap">
                            <user-appointment-status :statusId="appointment.statusId"></user-appointment-status>
                        </td>
                        <td class="text-nowrap">
                            <template v-if="appointment.consultationStatusId === 1">
                                <a href="javascript: void(0);" @click="startSession(appointment.consultationId, appointment.consultationTypeId)">
                                    Start Session
                                </a>|
                                <a href="javascript: void(0);" @click="cancelSession(appointment.id)">
                                    Cancel Session
                                </a>
                            </template>
                            <template v-else-if="appointment.consultationStatusId === 2">
                                <router-link :to="{
                                    'name': appointment.consultationTypeId === 1 ? 'doctor-consultation-detail' : 'doctor-consultation-no-pharmacy-detail',
                                    'params': {
                                        'id': appointment.consultationId
                                        }
                                    }">
                                    Start Session
                                </router-link>
                            </template>
                            <template v-else-if="appointment.consultationStatusId === 3">
                                <router-link :to="{
                                    'name': appointment.consultationTypeId === 1 ? 'doctor-consultation-detail' : 'doctor-consultation-no-pharmacy-detail',
                                    'params': {
                                        'id': appointment.consultationId
                                        }
                                    }">
                                    View Details
                                </router-link>
                            </template>
                            <template v-else>
                                -
                            </template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <popup-modal ref="popupModalConfirmation" :hasCloseButton="false" title="Cancel Session">
            <template slot="content">
                <p>{{confirmationMessage}}</p>

                <template v-if="!isCancelling">
                    <label>Reason</label>
                    <input id="inputReason" type="text" class="form-control" placeholder="Enter reason" v-model="cancelReason">
                </template>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-danger" @click="confirmCancelSession">Cancel Session</button>
                <button type="button" class="btn btn-secondary" @click="dismissCancelSession">Cancel</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
import userAppointmentStatus from '@/components/appointment-status/user';
import moment from 'moment';
export default {
    'name': 'DoctorConsultations',
    'components': {
        userAppointmentStatus,
        popupModal
    },
    data () {
        return {
            'appointmentList': [],
            'columnsCount': 1,
            'isTableLoading': true,
            'shouldUpdate': true,
            'isCancelling': false,
            'confirmationMessage': null,
            'cancelReason': null
        };
    },
    beforeRouteLeave (to, from, next) {
        this.shouldUpdate = false;
        next();
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;
        this.getAppointments();
    },
    'methods': {
        getAppointments () {
            this.axios.post('Appointment/GetDoctorAppointments', {
                's': [2, 1000]
            }).then(({
                data
            }) => {
                this.isTableLoading = false;
                this.appointmentList = data.data.map((appointment) => ({
                    'id': appointment.ai,
                    'date': appointment.ss ? moment(appointment.ss).format('DD/MM/YYYY') : null,
                    'time': appointment.ss ? moment(appointment.ss).format('hh:mm A') : null,
                    'patientName': appointment.cp ? appointment.cp.fn : '-',
                    'status': appointment.s ? appointment.s : '-',
                    'statusId': appointment.si,
                    'consultationId': appointment.sid,
                    'consultationStatusId': appointment.dc ? appointment.dc.cs : 0,
                    'consultationTypeId': appointment.dc ? appointment.dc.ct : 2
                }));

                if (this.shouldUpdate) {
                    setTimeout(() => {
                        this.getAppointments();
                    }, 2000);
                }
            })
                .catch(({
                    response
                }) => {

                });
        },
        startSession (consultationId, consultationTypeId) {
            this.axios.post('Consultation/StartConsultation', null, {
                'params': {
                    'consultationId': consultationId
                }
            }).then(() => {
                let routeName = consultationTypeId === 1 ? 'doctor-consultation-detail' : 'doctor-consultation-no-pharmacy-detail';
                this.$router.push({
                    'name': routeName,
                    'params': {
                        'id': consultationId
                    }
                });
            }).catch(({
                response
            }) => {

            });
        },
        cancelSession (appointmentId) {
            this.isCancelling = false;
            this.cancelAppointmentId = appointmentId;
            this.confirmationMessage = 'Are you sure you want to cancel this consultation session? This action cannot be undone.';

            this.$refs.popupModalConfirmation.show();
        },
        confirmCancelSession () {
            this.isCancelling = true;
            this.confirmationMessage = 'Cancelling consultation session...';
            this.axios.post('Appointment/DoctorCancelAppointment', null, {
                'params': {
                    'appointmentId': this.cancelAppointmentId,
                    'cancelReason': this.cancelReason
                }
            }).then(() => {
                this.dismissCancelSession();
            }).catch(() => {
                alert('Error cancelling appointment. Please try again.');
            });
        },
        dismissCancelSession () {
            this.cancelReason = null;
            this.cancelAppointmentId = null;
            this.$refs.popupModalConfirmation.hide();
        }
    }
};

</script>

<style>

</style>
